import type { Source } from '@netpurpose/types'
import { convertStringToEnum, valueIsDefined } from '@netpurpose/utils'
import { pickBy } from 'lodash'
import { ReportTypes, SourceStatus, SourceType } from '../../generated/facts'
import { formatDateForBackend } from '../datetime'
import type { BackendSource } from './parseSource'

export const formatSource = (source: Partial<Source>): Partial<BackendSource> => ({
  ...pickBy(
    {
      source_id: source.id,
      name: source.name,
      start: source.start ? formatDateForBackend(source.start) : undefined,
      end: source.end ? formatDateForBackend(source.end) : undefined,
      publishing_date: source.publishingDate
        ? formatDateForBackend(source.publishingDate)
        : undefined,
      original_url: source.originalUrl,
      // NOTE: this is a temp shortcut, we should switch to use BE enums
      report_type: source.reportType
        ? convertStringToEnum(source.reportType as string, ReportTypes)
        : undefined,
      checksum: source.checksum,
      entity_id: source.entityId || undefined,
      status: source.status
        ? convertStringToEnum(source.status as string, SourceStatus)
        : undefined,
    },
    valueIsDefined,
  ),
  url: source.url || '',
  file_type: convertStringToEnum(source.fileType as string, SourceType),
})
